<template>
    <div>
        <div class="row">
      <span class="font-weight-bold">
        Futamidő
      </span>
            <span class="font-weight-light">
        (hónap)
      </span>
        </div>
        <div class="row mb-2">
            <div
                v-for="each of contractLengths"
                :key="'contract_lengths' + each"
                class="col"
            >
                <button
                    type="button"
                    :class="{'btn-light': each !== contractLength, 'btn-primary': each === contractLength }"
                    class="btn btn-square btn-sm btn-block"
                    @click="setContractLength(each)"
                >
                    {{ each }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import { Component } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const priceSearchModule = namespace('price_search');

  @Component
  export default class PriceSearchContractLengthSelector extends Vue {
    @priceSearchModule.Getter('getContractLengths') contractLengths;
    @priceSearchModule.Getter('getContractLength') contractLength;
    @priceSearchModule.Mutation('setContractLength') setContractLength;
  }
</script>
